import { render, staticRenderFns } from "./AxSharedWith.vue?vue&type=template&id=7ed0d852&scoped=true&"
import script from "./AxSharedWith.vue?vue&type=script&lang=ts&"
export * from "./AxSharedWith.vue?vue&type=script&lang=ts&"
import style0 from "./AxSharedWith.vue?vue&type=style&index=0&id=7ed0d852&prod&lang=scss&"
import style1 from "./AxSharedWith.vue?vue&type=style&index=1&id=7ed0d852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed0d852",
  null
  
)

export default component.exports